"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _lego = _interopRequireDefault(require("../../lego"));
var _cookie = require("../../utils/cookie");
var _common = require("../../utils/common");
var _db = _interopRequireDefault(require("../../utils/db"));
var _log = _interopRequireDefault(require("../../utils/log"));
var _package = _interopRequireDefault(require("../../../package.json"));
var SDK_VERSION = _package.default.version;
var loadScript = function loadScript(src) {
  try {
    var script = document.createElement('script');
    script.src = src;
    script.onerror = function () {
      _log.default.error('加载埋点开发者工具失败');
    };
    script.onload = function () {
      _log.default.info('加载埋点开发者工具成功');
    };
    document.getElementsByTagName('body')[0].appendChild(script);
  } catch (e) {
    _log.default.error("\u57CB\u70B9\u5F00\u53D1\u8005\u5DE5\u5177\u8FDC\u7A0B\u52A0\u8F7D\u5931\u8D25, ".concat(e.message));
  }
};
var loadDevTool = function loadDevTool() {
  loadScript("https://s1.zhuanstatic.com/common/open/lego_devtool.js?t=".concat(new Date().getTime()));
};
var loadBaseInfo = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(db, params) {
    var urlQueryObj, _ref2, cookieid, timestamp, pagetype, appid, ua, version, clienttime, os, osv, lat, lon, resolution, devid, clientip, city, apn, baseInfo;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          urlQueryObj = {};
          if (typeof window !== 'undefined') {
            urlQueryObj = (0, _common.parseUrlQuery)(window.location.href);
          }
          _ref2 = _lego.default.getDefaultParam(), cookieid = _ref2.cookieid, timestamp = _ref2.timestamp, pagetype = _ref2.pagetype, appid = _ref2.appid, ua = _ref2.ua, version = _ref2.version, clienttime = _ref2.clienttime, os = _ref2.os, osv = _ref2.osv, lat = _ref2.lat, lon = _ref2.lon, resolution = _ref2.resolution, devid = _ref2.devid, clientip = _ref2.clientip, city = _ref2.city, apn = _ref2.apn;
          baseInfo = [{
            label: '基本信息',
            key: 1,
            infos: {
              app_id: appid,
              channelid: (0, _cookie.getCookie)('channelid'),
              't值': (0, _cookie.getCookie)('t'),
              'lego版本': SDK_VERSION
            }
          }, {
            label: '用户',
            key: 2,
            infos: {
              'cookieid唯一id': cookieid,
              uid: (0, _common.getUid)(),
              ppu: (0, _cookie.getPPU)()
            }
          }, {
            label: '公共参数',
            key: 3,
            infos: {
              ua: ua,
              '客户端版本': version,
              '操作系统': os,
              '操作系统版本': osv,
              '屏幕分辨率': resolution,
              '来源': document.referrer,
              lat: lat,
              lon: lon,
              devid: devid,
              clientip: clientip,
              city: city,
              '网络地址apn': apn,
              clienttime: clienttime
            }
          }, {
            label: '配置',
            key: 4,
            infos: {
              '自动页面mark': params !== null && params !== void 0 && params.setCloseMark ? '开启' : '没有开启',
              '停留时长': params !== null && params !== void 0 && params.stayUserTime ? '开启' : '没有开启',
              log: params !== null && params !== void 0 && params.log ? '开启' : '没有开启',
              t: params === null || params === void 0 ? void 0 : params.t,
              routeList: params === null || params === void 0 ? void 0 : params.routeList,
              name: params === null || params === void 0 ? void 0 : params.name,
              pagequery: params === null || params === void 0 ? void 0 : params.pagequery,
              pageIdInfo: params === null || params === void 0 ? void 0 : params.pageIdInfo,
              forbidLegoInPrerender: params !== null && params !== void 0 && params.forbidLegoInPrerender ? '开启' : '没有开启',
              forbidLegoInHidden: params !== null && params !== void 0 && params.forbidLegoInHidden ? '开启' : '没有开启',
              subpageID: params === null || params === void 0 ? void 0 : params.subpageID,
              debugger: params !== null && params !== void 0 && params.debugger ? '开启' : '没有开启',
              mchannel: params === null || params === void 0 ? void 0 : params.mchannel
            }
          }, {
            label: '页面',
            key: 5,
            infos: {
              'origin': location.origin,
              'hash': location.hash,
              'query': urlQueryObj,
              href: location.href
            }
          }]; // 清空数据 存在bug在首次的时候awiat的时候会阻断代码的执行，导致第一次没法写入数据
          _context2.next = 7;
          return db.clearStore('baseInfo');
        case 7:
          setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return db.putData('baseInfo', {
                    time: new Date().getTime(),
                    data: baseInfo
                  });
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })), 1000);
          _context2.next = 13;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](0);
          _log.default.warn("\u5B58\u50A8\u57FA\u7840\u4FE1\u606F\u51FA\u9519".concat(_context2.t0));
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 10]]);
  }));
  return function loadBaseInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var loadDebuggerModule = function loadDebuggerModule() {
  var debugCss = "#debugger-applog-web {\n    position: fixed;\n    width: 130px;\n    height: 30px;\n    background: #1677ff;\n    border-radius: 6px;\n    color: #fff;\n    font-size: 12px;\n    bottom: 5%;\n    right: 10%;\n    line-height: 30px;\n    cursor: pointer;\n    z-index:100;\n  }";
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.appendChild(document.createTextNode(debugCss));
  head.appendChild(style);
  var debuggerHtml = "<div id=\"debugger-applog-web\"></div>";
  var debugDiv = document.createElement('div');
  debugDiv.innerHTML = debuggerHtml;
  document.getElementsByTagName('body')[0].appendChild(debugDiv);
};
var debuggerTool = function debuggerTool(params) {
  if (typeof window === 'undefined') {
    return;
  }
  if (window.indexedDB) {
    var db = (0, _db.default)();
    loadBaseInfo(db, params);
    loadDebuggerModule();
    loadDevTool();
  } else {
    _log.default.error('浏览器不支持indexedDB，不能开启调试工具');
  }
};
var _default = debuggerTool;
exports.default = _default;